import * as React from 'react';

import { Center, TableCellProps, VStack, HStack, Table, Text, Spinner } from '@chakra-ui/react';
import { Res } from 'core/api';
import { SvgIcon } from 'core/ui-next';
import * as Images from 'pos/Images';
import { TableProps } from './types';



export function LargeSearchCustomerTable(props: TableProps): React.ReactNode {

	const { customers, selectedCustomer, onSelectCustomer, loading, searchResultInfo, MAX_CUSTOMERS_TO_FIND } = props;

	return <Table.ScrollArea w={'full'} maxH={'100'} rounded={'md'} >
		<Table.Root striped interactive stickyHeader>
			<Table.Header>
				<Table.Row>
					<Table.ColumnHeader w={'46'} minW={'46'}>
						<HStack gap={'1'} justifyContent={'start'}>
							<SvgIcon src={Images.Journal} width={'4'} height={'4'} />
							<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SET_BUYER_CUSTOMER_CUSTOMERS_CLM()}</Text>
						</HStack>
					</Table.ColumnHeader>
					<Table.ColumnHeader w={'24.5'} minW={'24.5'}>
						<HStack gap={'1'} justifyContent={'center'}>
							<SvgIcon src={Images.Cif} width={'4'} height={'4'} />
							<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SET_BUYER_CUSTOMER_CIF_CLM()}</Text>
						</HStack>
					</Table.ColumnHeader>
					<Table.ColumnHeader w={'66.5'} minW={'66.5'}>
						<HStack gap={'1'} justifyContent={'center'}>
							<SvgIcon src={Images.Location} width={'4'} height={'4'} />
							<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SET_BUYER_CUSTOMER_ADDRESS_CLM()}</Text>
						</HStack>
					</Table.ColumnHeader>
					<Table.ColumnHeader w={'36'} minW={'36'}>
						<HStack gap={'1'} justifyContent={'center'}>
							<SvgIcon src={Images.User} width={'3.5'} height={'3.5'} />
							<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SET_BUYER_CUSTOMER_CONTACT_CLM()}</Text>
						</HStack>
					</Table.ColumnHeader>
					<Table.ColumnHeader w={'30'} minW={'30'}>
						<HStack gap={'1'} justifyContent={'center'}>
							<SvgIcon src={Images.Phone} width={'3.5'} height={'3.5'} />
							<Text fontSize={'sm'} fontWeight={'semibold'} color={{ base: '{colors.neutral.800}', _dark: 'white' }}>{Res.Web.SET_BUYER_CUSTOMER_PHONE_CLM()}</Text>
						</HStack>
					</Table.ColumnHeader>
				</Table.Row>
			</Table.Header>
			<Table.Body>
				{loading ?
					<Table.Row h={'full'}>
						<Table.Cell colSpan={5}>
							<Center>
								<Spinner color={{ base: '{colors.yellow.500}', _dark: '{colors.yellow.500}' }} h={'12'} w={'12'} borderWidth={'medium'} />
							</Center>
						</Table.Cell>
					</Table.Row>
					: customers.length === 0 && searchResultInfo !== '' ?
						<Table.Row h={'full'}>
							<Table.Cell colSpan={5}>
								<Text fontSize={'md'} fontWeight={'semibold'} w={'full'} textAlign={'center'}>{searchResultInfo}</Text>
							</Table.Cell>
						</Table.Row>
						: <>
							{customers.length >= MAX_CUSTOMERS_TO_FIND && searchResultInfo !== '' &&
								<Table.Row h={'full'}>
									<Table.Cell colSpan={5}>
										<Text fontSize={'md'} fontWeight={'semibold'} w={'full'} textAlign={'center'}>{searchResultInfo}</Text>
									</Table.Cell>
								</Table.Row>}
							{customers.map((customer, index) => {
								const cellBackGround: TableCellProps['bg'] = selectedCustomer !== null && selectedCustomer.Id === customer.Id ? { base: '{colors.blue.200}', _dark: '{colors.blue.500}' } : undefined;
								const hasSecondLevel = Boolean(customer.BusinessName !== '' && customer.BusinessName !== null && customer.BusinessName !== undefined);

								return (
									<Table.Row key={index} onClick={() => onSelectCustomer(customer)} cursor={'pointer'}>
										<Table.Cell bg={cellBackGround} w={'46'} minW={'46'} maxW={'46'}>
											<VStack>
												<HStack w={'full'} minH={'5'} gap={'0.5'} textAlign={'start'}>
													<Text lineClamp={'1'} fontSize={'sm'}>{customer.FiscalName}</Text>
												</HStack>
												{hasSecondLevel &&
													<HStack w={'full'} minH={'5'} gap={'0.5'} textAlign={'start'}>
														<Text lineClamp={'1'} fontSize={'xs'} color={{ base: '{colors.neutral.500}', _dark: '{colors.neutral.400}' }}>{customer.BusinessName}</Text>
													</HStack>
												}
											</VStack>
										</Table.Cell>
										<Table.Cell bg={cellBackGround} w={'24.5'} minW={'24.5'} maxW={'24.5'}>
											<VStack>
												<HStack minH={'5'} gap={'0.5'} textAlign={'center'}>
													<Text lineClamp={'1'} fontSize={'sm'}>{customer.Cif}</Text>
												</HStack>
												{hasSecondLevel &&
													<HStack minH={'5'} gap={'0.5'} textAlign={'center'}>
														<></>
													</HStack>
												}
											</VStack>
										</Table.Cell>
										<Table.Cell bg={cellBackGround} w={'66.5'} minW={'66.5'} maxW={'66.5'}>
											<VStack>
												<HStack minH={'5'} gap={'0.5'} textAlign={'center'}>
													<Text lineClamp={'1'} fontSize={'sm'}>{customer.Address.Street + ' ' + customer.Address.ZipCode + ' ' + customer.Address.City}</Text>
												</HStack>
												{hasSecondLevel &&
													<HStack minH={'5'} gap={'0.5'} textAlign={'center'}>
														<></>
													</HStack>
												}
											</VStack>
										</Table.Cell>
										<Table.Cell bg={cellBackGround} w={'36'} minW={'36'} maxW={'36'}>
											<VStack>
												<HStack minH={'5'} gap={'0.5'} textAlign={'center'}>
													<Text lineClamp={'1'} fontSize={'sm'}>{customer.ContactPerson}</Text>
												</HStack>
												{hasSecondLevel &&
													<HStack minH={'5'} gap={'0.5'} textAlign={'center'}>
														<></>
													</HStack>
												}
											</VStack>
										</Table.Cell>
										<Table.Cell bg={cellBackGround} w={'30'} minW={'30'} maxW={'30'}>
											<VStack>
												<HStack minH={'5'} gap={'0.5'} textAlign={'center'}>
													<Text lineClamp={'1'} fontSize={'sm'}>{customer.Telephone}</Text>
												</HStack>
												{hasSecondLevel &&
													<HStack minH={'5'} gap={'0.5'} textAlign={'center'}>
														<></>
													</HStack>
												}
											</VStack>
										</Table.Cell>
									</Table.Row>
								);
							})}
						</>
				}
			</Table.Body>
		</Table.Root>
	</Table.ScrollArea>;
}
